import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Temporal } from '@js-temporal/polyfill';
import * as _ from 'lodash';
import { PlageHoraire } from 'src/app/domain/plage-horaire';


@Component({
    selector: 'app-plage-box',
    templateUrl: './plage-horaire-box.html',
    styleUrls: ['./plage-horaire-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PlageHoraireBoxDialog implements OnInit {

    public Model: PlageHoraire = new PlageHoraire();
    public interventionTimeDebut!: string;
    public interventionTimeFin!: string;

    Debut: Date = new Date();
    Fin: Date = new Date();

    constructor(
        public dialogRef: MatDialogRef<PlageHoraireBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data: PlageHoraire) {

        // if (data) {
        //     this.Model = Object.assign({}, data)
        // }Temporal.Now.plainDateISO()
        this.Model.Debut = Temporal.Now.plainDateTimeISO();
        this.Model.Fin = Temporal.Now.plainDateTimeISO();

        this.setTimeDebut()
        this.setTimeFin()
    }

    ngOnInit() { }

    canSave() {
        return this.interventionTimeDebut && this.interventionTimeFin && Temporal.PlainDateTime.compare(this.Model.Debut , this.Model.Fin) < 0;
    }

    debutChanged(event: MatDatepickerInputEvent<Date>) {
        this.Model.Debut = Temporal.PlainDateTime.from({year: this.Debut.getFullYear(), day: this.Debut.getDate(), month: this.Debut.getMonth() + 1, hour: this.Debut.getHours(), minute: this.Debut.getMinutes()});
        this.interventionTimeDebut = '';
    }


    timeSetDebut(event: string) {
        const time = event.split(':');

        this.Debut = new Date(this.Debut);
        this.Debut.setHours(Number(time[0]), Number(time[1]));
        this.Model.Debut = Temporal.PlainDateTime.from({year: this.Debut.getFullYear(), day: this.Debut.getDate(), month: this.Debut.getMonth() + 1, hour: this.Debut.getHours(), minute: this.Debut.getMinutes()});
        this.setTimeDebut();
    }

    setTimeDebut() {
        this.interventionTimeDebut = `${this.Debut.getHours()}:${this.Debut.getMinutes()}`;
    }


    finChanged(event: MatDatepickerInputEvent<Date>) {
        this.Model.Fin = Temporal.PlainDateTime.from({year: this.Fin.getFullYear(), day: this.Fin.getDate(), month: this.Fin.getMonth() + 1, hour: this.Fin.getHours(), minute: this.Fin.getMinutes()});
        this.interventionTimeFin = '';
    }

    timeSetFin(event: string) {
        const time = event.split(':');

        this.Fin = new Date(this.Fin);
        this.Fin.setHours(Number(time[0]), Number(time[1]));
        this.Model.Fin = Temporal.PlainDateTime.from({year: this.Fin.getFullYear(), day: this.Fin.getDate(), month: this.Fin.getMonth() + 1, hour: this.Fin.getHours(), minute: this.Fin.getMinutes()});
        this.setTimeFin();
    }

    setTimeFin() {
        this.interventionTimeFin = `${this.Fin.getHours()}:${this.Fin.getMinutes()}`;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.dialogRef.close(this.Model);
    }
}
